export default function SectionEyebrow({ children, align = "left" }) {
    return (
        <div
            className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}
        >
            <span className="h-px w-10 bg-gradient-to-r from-gold-300 to-transparent" />
            <span className="label-eyebrow">{children}</span>
        </div>
    );
}
